import { Box, Heading, Stack } from '@chakra-ui/react';
import { Button, Divider } from '@diamond/shared/ui';
import Link from 'next/link';
import { useRouter } from 'next/router';

export interface BuyerProfileProps {
  children: React.ReactNode;
}

export function BuyerProfileLayout({ children }: BuyerProfileProps) {
  const router = useRouter();

  return (
    <Box flex="1">
      <Heading fontSize="2xl" fontWeight="semibold">
        Akun
      </Heading>
      <Divider mt="5" borderColor="gray.33" />
      <Box overflow="auto">
        <Stack
          direction="row"
          spacing="4"
          py="6"
          w={{ base: 'lg', md: 'full' }}
        >
          <Link href="/profile">
            <Button
              isActive={router.pathname === '/profile'}
              _active={{
                bg: 'rgba(0, 0, 163, 0.1)',
                color: 'blue',
                borderColor: 'blue',
              }}
            >
              Detail Akun
            </Button>
          </Link>
          <Link href="/profile/payment-info">
            <Button
              isActive={router.pathname === '/profile/payment-info'}
              _active={{
                bg: 'rgba(0, 0, 163, 0.1)',
                color: 'blue',
                borderColor: 'blue',
              }}
            >
              Info Pembayaran
            </Button>
          </Link>
          <Link href="/profile/addresses">
            <Button
              isActive={router.pathname === '/profile/addresses'}
              _active={{
                bg: 'rgba(0, 0, 163, 0.1)',
                color: 'blue',
                borderColor: 'blue',
              }}
            >
              Alamat
            </Button>
          </Link>
          <Link href="/profile/password">
            <Button
              isActive={router.pathname === '/profile/password'}
              _active={{
                bg: 'rgba(0, 0, 163, 0.1)',
                color: 'blue',
                borderColor: 'blue',
              }}
            >
              Ubah Kata Sandi
            </Button>
          </Link>
        </Stack>
      </Box>
      <Box minH="450px">{children}</Box>
    </Box>
  );
}

export default BuyerProfileLayout;
